import React from 'react'
import { pure } from 'recompose'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { withRouter } from 'react-router-dom'
import AppBar from 'material-ui-next/AppBar'
import withStyles from 'material-ui-next/styles/withStyles'
import MainToolbar from './MainToolbar'
import SecondayToolbar from './SecondayToolbar'
import FiltersToolbar from './FiltersToolbar'
import { getTopBarConfig } from '../../selectors'
import breakpoints from '../../styles/breakpoints'

const styles = theme => ({
  root: {
    '&.openFilters': {
      [`@media (max-width: ${breakpoints.xs})`]: {
        bottom: 0,
      },
    },
  },
})

const TopBar = ({ hasFilters, openFilters, classes }) => (
  <AppBar
    position="fixed"
    elevation={0}
    classes={{ root: classNames(classes.root, { openFilters }) }}>
    <MainToolbar />
    <SecondayToolbar />
    {hasFilters && <FiltersToolbar />}
  </AppBar>
)

const mapStateToProps = state => {
  const config = getTopBarConfig(state)
  return {
    hasFilters: config.hasFilters,
    openFilters: config.openFilters,
  }
}

export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(pure(TopBar)))
)



// WEBPACK FOOTER //
// ./src/common/TopBar/TopBar.js